import React from 'react';
import { useTableColumnsListService } from '../../../../hooks/ListService/useTableColumnsListService';
import { Spin, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import './TableListService.scss';
import { useSelector } from 'react-redux';

export const TableListService = ({ onEdit }) => {
  const { t } = useTranslation();
  const { listService, isLoading } = useSelector((state) => state.eduServiceRegistry);
  const columns = useTableColumnsListService(listService, onEdit);

  return (
    <Spin tip={t('intersections.loadingPleaseWait') + '...'} spinning={isLoading}>
      <Table columns={columns} dataSource={listService} size="small" bordered />
    </Spin>
  );
};
